/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext } from 'react';
import { FormSectionGlobal } from '@fitinsur/components';
import { PartiesDocumentsSection } from '../index';
import { GlobalAuthContext } from 'store/context';

function RenderSection({
    formikRef,
    formikProps,
    questionnaire,
    idOperation,
    idProduct,
    globalQuestionnaire,
    setQuestionnaire,
    files,
    setFiles,
    setNewFile,
    sendFiles,
    setSendFiles,
    setHasContactsParties
}) {
    const authContext = useContext(GlobalAuthContext);

    return (
        <FormSectionGlobal
            sectionName="PARTIES_DOCUMENTS"
            formikRef={formikRef}
            values={{ ...formikProps.values, translateText: true, partiesDocuments: true }}
            errors={formikProps.errors}
            setFieldValue={formikProps.setFieldValue}
            setFieldError={formikProps.setFieldError}
            questionnaire={questionnaire}
            idOperation={idOperation}
            idProduct={idProduct}
            setQuestionnaire={setQuestionnaire}
            contextOfApp={authContext}
            onQuestionChange={(
                question,
                value,
                questionnaireUpdated,
                setQuestionnaireUpdated,
                setFieldValue
            ) =>
                PartiesDocumentsSection.events.handleQuestionChange({
                    question,
                    value,
                    questionnaireUpdated,
                    setQuestionnaireUpdated,
                    setFieldValue,
                    globalQuestionnaire,
                    files,
                    setFiles,
                    setNewFile,
                    sendFiles,
                    setSendFiles,
                    setHasContactsParties,
                })
            }
        />
    );
}

const components = {
    RenderSection
};

export { components };